module.exports = __webpack_public_path__ + "static/img/overview_flow.d1b3a79f.png";